import { TWebsiteBuilderConfigAction, WebsiteBuilderConfigActionType } from "redux/actions/websiteBuilder/config/websiteBuilderConfigAction";
import { IWebsiteBuilderWebsite } from "../models/websiteBuilder";

export type TWebsiteBuilderWebsiteLoadingStatus = "standby" | "loading" | "failed" | "succeeded";

export interface IWebsiteBuilderConfig {
  website: IWebsiteBuilderWebsite;
  websiteExists: boolean;
  websiteLoadingStatus: TWebsiteBuilderWebsiteLoadingStatus;
}

export const websiteBuilderInitialConfig: IWebsiteBuilderConfig = {
  website: null,
  websiteExists: false,
  websiteLoadingStatus: "standby",
};

export function websiteBuilderConfigReducer(config: IWebsiteBuilderConfig, action: TWebsiteBuilderConfigAction): IWebsiteBuilderConfig {
  if (action.type === WebsiteBuilderConfigActionType.START_LOADING_WEBSITE) {
    return {
      ...config,
      websiteLoadingStatus: "loading",
    };
  } else if (action.type === WebsiteBuilderConfigActionType.LOAD_WEBSITE) {
    const { website, websiteLoadingStatus } = action.payload;

    return {
      ...config,
      website,
      websiteExists: website != null,
      websiteLoadingStatus,
    };
  } else if (action.type === WebsiteBuilderConfigActionType.SET_WEBSITE) {
    const { website } = action.payload;

    return {
      ...config,
      website,
      websiteExists: website != null,
    };
  } else {
    return config;
  }
}